import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { delay } from "rambda"
import {
  type ExternalToast,
  Toaster as Sonner,
  type ToasterProps,
  toast as toastFn,
} from "sonner"

const Toaster = ({ ...props }: ToasterProps)=> {
  return (
    <Sonner
      className="toaster group"
      icons={{
        error: <OctagonXIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
        success: <CircleCheckIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
      }}
      theme="light"
      toastOptions={{
        style: {
          background: "var(--color-primary)",
          color: "contrast-color(var(--color-primary))",
        },
      }}
      {...props}
    />
  )
}

const toast = {
  error: (message, options?: ExternalToast)=> {
    toastFn.error(message, {
      ...options,
      style: {
        background: "var(--color-destructive)",
        color: "contrast-color(var(--color-destructive))",
      },
    })
  },
  info: toastFn.info,
  success: toastFn.success,
  warning: toastFn.warning,
}
const toastAsync = {
  info: async (message: string, ms: number)=> {
		toast.success(message)
		await delay(ms)
  },
}

export { toast, toastAsync, Toaster }
